import { TRACKING_TYPE } from '@/utils/constants';
import React, { FunctionComponent, useState } from 'react';
import ChannelOptionButton, { ChannelOptionButtonValues } from '../ChatbotUI/ChannelOptionButton';

import Live from '../Live';
import { LiveComponentFromDialogueSource } from '../Live/constants';

import './style.scss';

interface Props {
  content: string;
  liveButtonInfo: {
    btnContent: string;
  };
  channelButtonInfos: ChannelOptionButtonValues[];
}

const ChannelOptionLive: FunctionComponent<Props> = (props) => {
  const { content, liveButtonInfo, channelButtonInfos, ...otherProps } = props;

  return (
    <div className="channel-option-live">
      <Live
        buttonClassName="live-button"
        msgContent={content}
        {...liveButtonInfo}
        {...otherProps}
        disabledBtn={(props as any)?.disabledBtn}
        source={LiveComponentFromDialogueSource.ChannelOptionLive}
        trackingname={TRACKING_TYPE.CHANNEL_SELECTION}
      />
      <ChannelOptionButton
        buttons={channelButtonInfos}
        {...otherProps}
        trackingname={TRACKING_TYPE.CHANNEL_SELECTION}
        disabledBtn={(props as any)?.disabledBtn}
      />
    </div>
  );
};

export default ChannelOptionLive;
